import React from 'react';
import {
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    SimpleForm,
    TextInput,
    BooleanInput,
    BooleanField,
    Filter
} from 'react-admin';

import { required, maxLength, minLength } from './../../utils/validations';

const CategoryFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="Name" />
        <BooleanInput source="enabled" label="Enable" />
    </Filter>
);



export const CategoryList = (props) => {
    const userType = atob(sessionStorage.getItem("zutp"));
    if (userType === 'SA' || userType === 'CA') {
        return (
            <List {...props} title={`Categories`} bulkActionButtons={false}
                filters={<CategoryFilter />} sort={{ field: "id", order: "DESC" }}>
                <Datagrid>
                    <TextField source="id" label="ID" />
                    <TextField source="name" label="Name" />
                    <BooleanField source="enabled" label="Enable" />
                    <EditButton />
                </Datagrid>
            </List>
        );
    }
    return (
        <List {...props} title={`Categories`} bulkActionButtons={false}
            filters={<CategoryFilter />} sort={{ field: "id", order: "DESC" }}>
            <Datagrid>
                <TextField source="id" label="ID" />
                <TextField source="name" label="Name" />
                <BooleanField source="enabled" label="Enable" />
                <EditButton />
            </Datagrid>
        </List>
    );
}

const validateName = [required(), minLength(2), maxLength(40)];


export const CategoryEdit = (props) => {
    const userType = atob(sessionStorage.getItem("zutp"));
    if (userType === 'SA' || userType === 'CA') {
        return (
            <Edit title={`Edit Category`} {...props}>
                <SimpleForm redirect="list" {...props}>
                    <TextInput label="Name" source="name" validate={validateName} />
                    <BooleanInput source="enabled" label="Enable" defaultValue={true} />
                </SimpleForm>
            </Edit>
        );
    }
    return (
        <Edit title={`Edit Category`} {...props}>
            <SimpleForm redirect="list" {...props}>
                <TextInput label="Name" source="name" validate={validateName} />
                <BooleanInput source="enabled" label="Enable" defaultValue={true} />
            </SimpleForm>
        </Edit>
    );
}

export const CategoryCreate = (props) => {
    const userType = atob(sessionStorage.getItem("zutp"));
    if (userType === 'SA' || userType === 'CA') {
        return (
            <Create title={`Create Category`} {...props}>
                <SimpleForm redirect="list">
                    <TextInput label="Name" source="name" validate={validateName} />
                    <BooleanInput source="enabled" label="Enable" defaultValue={true} />
                </SimpleForm>
            </Create>
        );
    }
    return (
        <Create title={`Create Category`} {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Name" source="name" validate={validateName} />
                <BooleanInput source="enabled" label="Enable" defaultValue={true} />
            </SimpleForm>
        </Create>
    );
}
